module.exports = __webpack_public_path__ + "static/media/linkedin.91d280f7.svg";